import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./slices/cartSlice";
import wishlistReducer from "./slices/wishlistSlice";

import authReducer from "./slices/authSlice";
import landingReducer from "./slices/landingSlice";
import shopReducer from "./slices/shopSlice";
import shopSettingsReducer from "./slices/shopSettingsSlice";
import termsReducer from "./slices/termsSlice";
import privacyReducer from "./slices/privacySlice";
import shopTermsReducer from "./slices/shopTermsSlice";
import shopPrivacyReducer from "./slices/shopPrivacySlice";
import shopAboutReducer from "./slices/shopAboutSlice";
import shopContactReducer from "./slices/shopContactSlice";
import shopHelpReducer from "./slices/shopHelpSlice";
import statsReducer from "./slices/statsSlice";
import themeReducer from "./slices/themeSlice";
import orderReducer from "./slices/orderSlice";
import couponReducer from "./slices/couponSlice";

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    wishlist: wishlistReducer,
    auth: authReducer,
    landing: landingReducer,
    shop: shopReducer,
    shopSettings: shopSettingsReducer,
    terms: termsReducer,
    privacy: privacyReducer,
    shopTerms: shopTermsReducer,
    shopPrivacy: shopPrivacyReducer,
    shopAbout: shopAboutReducer,
    shopContact: shopContactReducer,
    shopHelp: shopHelpReducer,
    stats: statsReducer,
    theme: themeReducer,
    orders: orderReducer,
    coupons: couponReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
